var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolAppBookingReminders01 = function SvgSolAppBookingReminders01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_app_booking_reminders-01_svg2__a",
    x1: 110.94,
    x2: 222.75,
    y1: 257.05,
    y2: 118.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3D43C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#5934b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7523a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#89179f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#9b0d98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_app_booking_reminders-01_svg2__a",
    id: "sol_app_booking_reminders-01_svg2__b",
    x1: 95.47,
    x2: 207.28,
    y1: 244.59,
    y2: 105.67
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_app_booking_reminders-01_svg2__a",
    id: "sol_app_booking_reminders-01_svg2__c",
    x1: 3.02,
    x2: 114.83,
    y1: 170.19,
    y2: 31.27
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_app_booking_reminders-01_svg2__a",
    id: "sol_app_booking_reminders-01_svg2__d",
    x1: 13.16,
    x2: 124.97,
    y1: 178.35,
    y2: 39.43
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_app_booking_reminders-01_svg2__a",
    id: "sol_app_booking_reminders-01_svg2__e",
    x1: 25.37,
    x2: 137.18,
    y1: 188.17,
    y2: 49.26
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_app_booking_reminders-01_svg2__a",
    id: "sol_app_booking_reminders-01_svg2__f",
    x1: -17.18,
    x2: 94.63,
    y1: 153.92,
    y2: 15.01
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_app_booking_reminders-01_svg2__a",
    id: "sol_app_booking_reminders-01_svg2__g",
    x1: -4.97,
    x2: 106.84,
    y1: 163.75,
    y2: 24.83
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_app_booking_reminders-01_svg2__a",
    id: "sol_app_booking_reminders-01_svg2__h",
    x1: 37.58,
    x2: 149.39,
    y1: 198,
    y2: 59.09
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_app_booking_reminders-01_svg2__a",
    id: "sol_app_booking_reminders-01_svg2__i",
    x1: 7.24,
    x2: 119.05,
    y1: 173.58,
    y2: 34.66
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M165.62 193.75h-12.5c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12h12.5c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12",
    style: {
      fill: "url(#sol_app_booking_reminders-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m194.67 171.5-3.66-3.66c-2.23-2.23-3.5-5.31-3.5-8.46v-18.75c0-12.22-7.84-22.61-18.75-26.48v-4.77c0-5.17-4.21-9.38-9.38-9.38s-9.37 4.21-9.37 9.38v4.77c-10.91 3.87-18.75 14.27-18.75 26.48v18.75c0 3.15-1.28 6.23-3.5 8.46l-3.66 3.66a18.33 18.33 0 0 0-5.33 12.88c0 1.73 1.4 3.12 3.12 3.12h12.5c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12h-8.95c.55-2 1.61-3.86 3.08-5.33l3.66-3.66c3.39-3.39 5.33-8.08 5.33-12.88v-18.75c0-12.06 9.82-21.88 21.88-21.88s21.88 9.82 21.88 21.88v18.75c0 4.79 1.94 9.49 5.33 12.88l3.66 3.66c1.48 1.48 2.54 3.33 3.08 5.33h-46.45c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12h50c1.73 0 3.12-1.4 3.12-3.12 0-4.79-1.94-9.49-5.33-12.88Zm-38.42-58.82v-3.31a3.124 3.124 0 0 1 6.25 0v3.31c-1.03-.12-2.07-.18-3.13-.18s-2.1.07-3.12.18",
    style: {
      fill: "url(#sol_app_booking_reminders-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.38 175H15.62c-5.17 0-9.37-4.21-9.37-9.38V62.5h134.38c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12H6.25V34.38c0-5.17 4.21-9.38 9.37-9.38h12.5v6.25c0 6.89 5.61 12.5 12.5 12.5h6.25c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12h-6.25c-3.45 0-6.25-2.8-6.25-6.25V12.5c0-3.45 2.8-6.25 6.25-6.25s6.25 2.8 6.25 6.25v6.25h-3.12c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12h65.62v6.25c0 6.89 5.61 12.5 12.5 12.5h6.25c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12h-6.25c-3.45 0-6.25-2.8-6.25-6.25V12.5c0-3.45 2.8-6.25 6.25-6.25s6.25 2.8 6.25 6.25v6.25h-3.13c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12h21.88c5.17 0 9.38 4.21 9.38 9.38v56.25c0 1.73 1.4 3.12 3.12 3.12s3.13-1.4 3.13-3.12V34.37c0-8.62-7.01-15.62-15.63-15.62h-12.5V12.5c0-6.89-5.61-12.5-12.5-12.5s-12.5 5.61-12.5 12.5v6.25H53.12V12.5c0-6.89-5.61-12.5-12.5-12.5s-12.5 5.61-12.5 12.5v6.25h-12.5C7 18.75 0 25.76 0 34.37v131.25c0 8.62 7.01 15.62 15.62 15.62h93.75c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12Z",
    style: {
      fill: "url(#sol_app_booking_reminders-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.5 90.62H50c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12h62.5c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12",
    style: {
      fill: "url(#sol_app_booking_reminders-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.5 115.62H50c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12h62.5c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12",
    style: {
      fill: "url(#sol_app_booking_reminders-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.25 84.38c-5.17 0-9.38 4.21-9.38 9.38s4.21 9.38 9.38 9.38 9.38-4.21 9.38-9.38-4.21-9.38-9.38-9.38m0 12.5c-1.73 0-3.12-1.4-3.12-3.12s1.4-3.12 3.12-3.12 3.12 1.4 3.12 3.12-1.4 3.12-3.12 3.12",
    style: {
      fill: "url(#sol_app_booking_reminders-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.25 109.38c-5.17 0-9.38 4.21-9.38 9.38s4.21 9.38 9.38 9.38 9.38-4.21 9.38-9.38-4.21-9.38-9.38-9.38m0 12.5c-1.73 0-3.12-1.4-3.12-3.12s1.4-3.12 3.12-3.12 3.12 1.4 3.12 3.12-1.4 3.12-3.12 3.12",
    style: {
      fill: "url(#sol_app_booking_reminders-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.5 140.62H50c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12h62.5c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12",
    style: {
      fill: "url(#sol_app_booking_reminders-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.25 134.38c-5.17 0-9.38 4.21-9.38 9.38s4.21 9.38 9.38 9.38 9.38-4.21 9.38-9.38-4.21-9.38-9.38-9.38m0 12.5c-1.73 0-3.12-1.4-3.12-3.12s1.4-3.12 3.12-3.12 3.12 1.4 3.12 3.12-1.4 3.12-3.12 3.12",
    style: {
      fill: "url(#sol_app_booking_reminders-01_svg2__i)"
    }
  }));
};
export default SvgSolAppBookingReminders01;